var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNode, flowNodeColor, NodeTypeComponent } from 'fable/flowEditor';
import OpeningHoursFromPayload from '../../components/openingHoursFromPayload';
import { createOpeningHoursModalContainer } from '../../containers/modals/openingHours';
import { formatPortsHelper } from '../../helpers/nodePortFormatter';
import { FlowNodeTypes } from '../types';
const portTranslator = (node) => [
    {
        id: uuid(),
        type: 'out',
        label: 'Closed',
        connection: node.payload.closedNodeId || uuid(),
    },
    {
        id: uuid(),
        type: 'out',
        label: 'Open',
        connection: node.payload.openNodeId || uuid(),
    },
];
export class OpeningHoursNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        const { node } = this.props;
        return (_jsx(FlowNode, { color: OpeningHoursNode.color, icon: OpeningHoursNode.icon, label: OpeningHoursNode.label, text: _jsx(OpeningHoursFromPayload, { node: node }), onEdit: this.triggerEdit }));
    }
}
OpeningHoursNode.icon = 'clock';
OpeningHoursNode.label = 'Opening hours';
OpeningHoursNode.helpText = 'By setting your opening hours, you can decide what happens to incoming conversations based on whether your business is open or closed.';
OpeningHoursNode.color = flowNodeColor.purple;
OpeningHoursNode.height = FlowNode.dimensions.h + 16;
OpeningHoursNode.translatePayload = formatPortsHelper(portTranslator);
OpeningHoursNode.ActionModal = createOpeningHoursModalContainer(false);
OpeningHoursNode.actionTrigger = { type: FlowNodeTypes.OPENING_HOURS };
OpeningHoursNode.updateConnection = (node, port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    const entryName = port.label === 'Open' ? 'openNodeId' : 'closedNodeId';
    payload[entryName] = newConnection;
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], OpeningHoursNode.prototype, "triggerEdit", null);
